<template>
  <div class="wrapper">
    <div class="p-3">
      <b-form @submit="onSubmit">
        <b-form-group
          id="input-group-1"
          label="Din E-postadresse"
          label-for="input-1"
          description="Vi vil svare deg på denne e-posten"
        >
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Angi e-post"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Hva kan vi hjelpe deg med?">
          <b-form-textarea
            id="textarea"
            v-model="text"
            placeholder="Hva lurer du på?"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>

        <b-button type="submit" variant="primary">Send melding</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  data() {
    return {
      form: {
        email: '',
        description: '',
      },
      show: true,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = '';
      this.form.name = '';
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>